import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">探索内容分类</h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大内容板块，总有一款适合你
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-500 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-accent-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                  <p className="mt-3 text-xs text-foreground-400">
                    {cat.articleCount} 篇文章
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}